import ga from 'react-ga';
import htmlToText from 'html2plaintext';

export const getShadowItem = (items) => {

  let maxTags = '';
  let maxTitle = '';
  let maxContent = '';

  for (const item of items) {
    if (item.tags && item.tags.length > maxTags.length) {
      maxTags = item.tags;
    }
    if (item.title.length > maxTitle.length) {
      maxTitle = item.title;
    }
    if (item.content.length > maxContent.length) {
      maxContent = item.content;
    }
  }

  return {
    tags: maxTags,
    title: maxTitle,
    content: maxContent,
  };
};

export const getTransformedItems = (rawItems) => {

  const transformedItems = [];

  let count = 0;
  for (const item of rawItems) {

    if (count < 4) {

      const ellipsisIndex = item.excerpt.indexOf('&hellip;');
      const excerpt = item.excerpt.substring(0, ellipsisIndex);

      transformedItems.push({
        tags: item.categories.join(', '),
        title: htmlToText(item.title),
        content: htmlToText(excerpt),
        user: item.author,
        url: item.permalink,
        date: item.date,
      });
    }

    count++;
  }

  return transformedItems;
};

const trackClick = (message) => {
  ga.event({
    category: 'UserClick',
    action: message,
  });
};

export const trackHostClick = (e, message) => {
  try {
    const tag = e.currentTarget.host.trim();
    trackClick(message + ': ' + tag);
  } catch(e) {}
};

export const trackInnerTextClick = (e, message) => {
  try {
    const tag = e.currentTarget.innerText.trim();
    trackClick(message + ': ' + tag);
  } catch(e) {}
};



// WEBPACK FOOTER //
// ./src/utils.js